import React, { FC } from 'react';
import { CircularProgress, Typography, makeStyles } from '@material-ui/core';
import { ProgressTrackerProps } from '.';

const circleSize = 120;
const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
  },
  circleContainer: {
    position: 'relative',
    display: 'flex',
    height: circleSize,
  },
  circleStepText: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.8rem',
  },
  bottomCircle: {
    color: theme.palette.grey[200],
  },
  topCircle: {
    color: theme.palette.success.main,
    position: 'absolute',
    left: 0,
    strokeLinecap: 'round',
  },
  stepsTextContainer: {
    padding: theme.spacing(2),
  },
  currentStepText: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  nextStepText: {
    fontWeight: 'normal',
    fontSize: '1.4rem',
    color: theme.palette.grey[600],
    alignItems: 'center',
  },
}));
const MobileProgressTracker = ({ steps }: ProgressTrackerProps) => {
  const classes = useStyles();
  const currentStep = steps.find(step => step.isActive);
  const currentStepIndex =
    currentStep?.index || steps.findIndex(step => step.isActive) + 1;
  const totalSteps = steps.length;
  const progressPercent = (currentStepIndex / totalSteps) * 100;
  return (
    <div data-testid="mobile-progress-tracker" className={classes.root}>
      <div className={classes.circleContainer}>
        <CircularProgress
          variant="static"
          value={100}
          size={circleSize}
          className={classes.bottomCircle}
        />
        <CircularProgress
          variant="static"
          value={progressPercent}
          size={120}
          className={classes.topCircle}
        />
        <Typography
          variant="caption"
          component="div"
          className={classes.circleStepText}
        >
          <b data-testid="current-step">{currentStepIndex} </b>
          <span>&nbsp;of&nbsp;</span>
          <b data-testid="total-steps"> {totalSteps}</b>
        </Typography>
      </div>
      <div className={classes.stepsTextContainer}>
        <div
          data-testid="current-step-label"
          className={classes.currentStepText}
        >
          {currentStep?.label}
        </div>
        <div data-testid="next-step-label" className={classes.nextStepText}>
          {!!steps[currentStepIndex] &&
            `Next: ${steps[currentStepIndex].label}`}
        </div>
      </div>
    </div>
  );
};

export default MobileProgressTracker;
